import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { CurrenciesService } from './currencies.service';
import { of } from 'rxjs';
import { selectCurrencies } from '~/modules/currencies/slice';
import * as fromActions from './slice';
import { isEmpty } from 'lodash-es';

@Injectable()
export class CurrenciesEffects {
  loadCurrenciesOnlyIfNotLoadedYet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadCurrenciesOnlyIfNotLoadedYet),
      concatLatestFrom(() => this.store.pipe(select(selectCurrencies))),
      filter(([_action, existingCurrencies]) => isEmpty(existingCurrencies)),
      switchMap(() =>
        this.currencyService.loadCurrencies().pipe(
          switchMap((currencies) => [
            fromActions.upsertCurrencies({ entities: currencies }),
            fromActions.loadCurrenciesSuccess()
          ]),
          catchError(() => of(fromActions.loadCurrenciesFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly currencyService: CurrenciesService
  ) {}
}
